import { openTelegramLink } from '@telegram-apps/sdk-react';
import { useTranslation } from 'react-i18next';

/** SPEC §8: telefon faqat bot orqali (request_contact) olinadi. */
export function PhoneBanner() {
  const { t } = useTranslation();
  const bot = import.meta.env.VITE_BOT_USERNAME;

  return (
    <div className="card mb-4 border-amber/40 p-5">
      <p className="mb-1 font-bold">📱 {t('phone.required')}</p>
      <p className="mb-4 text-sm text-muted">{t('phone.hint')}</p>
      {bot && (
        <button
          type="button"
          className="btn-secondary text-sm"
          onClick={() => {
            const url = `https://t.me/${bot}?start=phone`;
            if (openTelegramLink.isAvailable()) openTelegramLink(url);
            else window.open(url, '_blank');
          }}
        >
          {t('phone.openBot')} →
        </button>
      )}
    </div>
  );
}
